import React, { memo, useState, useEffect } from 'react';

import Card from '../reportCardWithRisk';
import SubSectionContainer from '../subSectionContainer';
import { Form, Skeleton } from 'antd';

import CollapseComp from '../components/collapse';
import {
  getOptionFromIndex,
  // getOptionFromValue,
  getOptionFromLevel,
  getAnswerValue,
  getLevelStringByPercent,
  clipFloat,
  getPercentByLevelString,
} from './strategy/strategyComplexyUtils';
import classNames from 'classnames';
import { deepCopy } from '@utils/common';
import alert from '@components/alert';
import { Prompt, withRouter } from 'react-router-dom';
import {
  calculateSectionScore,
  calculateScore,
  levelScore,
} from './strategy/caculateScore';
import RichEditor from '../richEditor';

const GetOptions = (props) => {
  const {
    optionCriteriaArr,
    isEditing,
    optionCriteria,
    label,
    answerValue,
    optionText: optionT,
    isStrategyCollapse,
    seqNum,
    optionLevel,
    index,
    isBPSI,
  } = props;

  const optionText = ((v) => {
    try {
      return JSON.parse(optionT);
    } catch {
      return optionT;
    }
  })();

  const renderEditComp = () => {
    if (isEditing) {
      if (!optionText?.title && !isBPSI) {
        return (
          <Form.Item
            label={label === true && answerValue}
            initialValue={optionText}
            name={`optionCriteria--${seqNum}--${
              seqNum !== 1 ? optionLevel : index
            }`}
            preserve
          >
            <RichEditor
              readOnly={!isEditing}
              value={optionText}
              className="complexity-textarea"
              autoSize={{ minRows: 3, maxRows: 5 }}
              linkPopoverProps={{
                placement: 'leftTop',
                overlayClassName:
                  'lifecycle-link-popover complexity-overall-link-adjust',
              }}
            />
          </Form.Item>
        );
      }
      if (isBPSI) {
        return <CollapseComp {...props} text={optionText} />;
      }
      if (optionText?.title || isStrategyCollapse) {
        return (
          <>
            {optionText?.title && (
              <Form.Item
                initialValue={optionText.title}
                name={[`optionCriteria--${seqNum}--${optionLevel}`, 'title']}
                preserve
              >
                <RichEditor
                  readOnly={!isEditing}
                  value={optionText.title}
                  className="complexity-textarea complexity-textarea-title"
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  linkPopoverProps={{
                    placement: 'leftTop',
                    overlayClassName:
                      'lifecycle-link-popover complexity-overall-link-adjust',
                  }}
                />
              </Form.Item>
            )}
            <CollapseComp
              {...props}
              text={optionText}
              optionText={optionText}
            />
            {optionText?.bottom && (
              <Form.Item
                initialValue={optionText.bottom}
                name={[`optionCriteria--${seqNum}--${optionLevel}`, 'bottom']}
                preserve
              >
                <RichEditor
                  readOnly={!isEditing}
                  value={optionText.bottom}
                  className="complexity-textarea complexity-textarea-title"
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  linkPopoverProps={{
                    placement: 'leftTop',
                    overlayClassName:
                      'lifecycle-link-popover complexity-overall-link-adjust',
                  }}
                />
              </Form.Item>
            )}
          </>
        );
      }
    }
  };

  return (
    <>
      {optionCriteriaArr && (
        <div key={optionCriteria} className={`option-${seqNum}`}>
          {renderEditComp()}
          {!isEditing && optionText?.title && (
            <RichEditor
              readOnly={!isEditing}
              value={optionText.title}
              className="complexity-textarea"
              autoSize={{ minRows: 3, maxRows: 5 }}
            />
          )}
          {!isEditing && optionText?.title && (
            <CollapseComp {...props} optionText={optionText} />
          )}
          {!isEditing && isBPSI && typeof optionText !== 'string' && (
            <CollapseComp {...props} />
          )}
          {!isEditing && optionText?.bottom && (
            <RichEditor
              readOnly={!isEditing}
              value={optionText?.bottom}
              className="complexity-textarea"
              autoSize={{ minRows: 3, maxRows: 5 }}
            />
          )}
          {!isEditing && !optionText?.title && !isBPSI && (
            <div className="option-text">
              {label && <div className="label">{answerValue}:</div>}
              <RichEditor
                readOnly={!isEditing}
                value={optionText}
                className="complexity-textarea"
                autoSize={{ minRows: 3, maxRows: 5 }}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

const getComp = ({ seqNum, comp, children, ...rest }) => {
  const Comp = comp[seqNum];
  const level = parseInt(rest.answer, 10) - 1;
  return (
    Comp && (
      <Comp {...rest} level={level}>
        {children && children}
      </Comp>
    )
  );
};
const Content = (props) => {
  const {
    compLocation = 'down',
    seqNum,
    // subTitle,
    optionCriteriaArr,
    optionCriteria,
    optionText,
    optionLevel,
    options,
    type,
    form,
    answerValue,
    isEditing,
    cancelPointEvent,
    changeRisk,
    changeSaveButton,
    answer,
    // selectMode,
    changeQuesLevel,
    // content,
    // showContentAsSubtitle = false,
  } = props;
  const [changedOption, setoption] = useState({
    optionLevel,
    optionText,
    optionCriteria,
  });
  const [changedAnswer, setAnswer] = useState(answer);

  const changeAnswerValue = (v, choices) => {
    let answerIndex;
    let newAnswerValue = answerValue;
    if (seqNum === 1) {
      newAnswerValue = getAnswerValue({ options, type }, v);
    }
    answerIndex = Array.isArray(v) ? Number(v[0]) : Number(v);

    const option = isNaN(answerIndex)
      ? getOptionFromLevel(optionCriteriaArr, v)
      : getOptionFromIndex(optionCriteriaArr, answerIndex.toString());

    const {
      criteria: optionCriteria,
      level: optionLevel,
      text: optionText,
      index,
    } = option;
    changeRisk(optionLevel, v);

    const res = form.getFieldsValue(true);
    if (choices && seqNum === 2) {
      if (choices.length === 0) {
        changeSaveButton(false);
      } else {
        changeSaveButton(true);
      }
    }
    // if()
    form.setFieldsValue({ ...res, [`answer-${seqNum}`]: choices || String(v) });
    setAnswer(choices || String(answerIndex));
    // debugger;
    changeQuesLevel({
      answer: choices || String(answerIndex),
      level: optionLevel,
    });

    setoption({
      optionCriteria,
      optionLevel,
      optionText,
      index,
      answerValue: newAnswerValue,
    });
  };

  const classes = classNames('comp-style', {
    'can-not-point': !isEditing && !cancelPointEvent,
  });
  // const TempOption = GetOptions({
  //   ...props,
  //   ...changedOption,
  // });
  useEffect(
    () => () => {
      changeSaveButton(true);
    },
    [],
  );
  useEffect(() => {
    setoption({});
    setAnswer(answer);
  }, [isEditing]);
  return (
    <div>
      {/* {content && (
        <div className="subTitle">
          {showContentAsSubtitle ? content : subTitle}
        </div>
      )} */}
      <div
        className={`section-${seqNum} ${
          compLocation === 'left' ? 'left-and-right' : ''
        }`}
      >
        <div className={classes}>
          {getComp({
            ...props,
            changeAnswerValue,
            answer: changedAnswer || answer,
          })}
        </div>
        {GetOptions({
          ...props,
          ...changedOption,
        })}
      </div>
    </div>
  );
};

const StrategyEditableContent = memo(
  ({ content, isEditing, onChange, value, level }) => (
    <div>
      {isEditing ? (
        <Form.Item initialValue={content} name={`${'top'}-${level}`}>
          <RichEditor
            readOnly={!isEditing}
            className="complexity-textarea"
            autoSize={{ minRows: 4, maxRows: 5 }}
            linkPopoverProps={{
              placement: 'leftTop',
              overlayClassName:
                'lifecycle-link-popover complexity-overall-link-adjust',
            }}
          />
        </Form.Item>
      ) : (
        // <pre>{content}</pre>
        <RichEditor
          readOnly={!isEditing}
          value={content}
          className="complexity-textarea"
          autoSize={{ minRows: 4, maxRows: 5 }}
        />
      )}
    </div>
  ),
);

const SectionContainer = memo((props) => {
  const {
    riskMitigation,
    riskMitigationaText,
    seqNum,
    optionLevel,
    isRiskEditng,
    form,
    handleCancel,
  } = props;
  const [risk, setRisk] = useState({ risk: riskMitigationaText, optionLevel });

  const changeRisk = (level, v) => {
    const risk = riskMitigation?.find((r) => {
      if (r.index) {
        return String(r.index[0]) === String(v);
      }
      return String(r.level) === String(level);
    });

    risk && setRisk({ risk: risk.text, optionLevel: level });
  };

  useEffect(() => {
    setRisk({ risk: riskMitigationaText, optionLevel });
  }, [handleCancel]);

  useEffect(() => {
    if (isRiskEditng) {
      riskMitigation.forEach((item) => {
        form.setFieldsValue({
          risk: {
            [`${seqNum}--${item.level}`]: item.text,
          },
        });
      });
    }
  }, [isRiskEditng]);
  return (
    <Card
      content={Content({ noHeader: true, changeRisk, ...props })}
      // content={<Content noHeader={true} changeRisk={changeRisk} {...props} />}
      noHeader={true}
      seqNum={seqNum}
      isRiskEditng={isRiskEditng}
      riskMitigation={riskMitigation}
      risk={risk.risk}
      optionLevel={risk.optionLevel}
      answer={props.answer}
    />
  );
});

const getLevelShouldShow = (_subLevels, _sectionNum, _idx) => {
  if (
    _sectionNum !== 1 ||
    _idx > 1 ||
    !Array.isArray(_subLevels[_idx]?.questionComplexity) ||
    _subLevels[_idx]?.questionComplexity[0]?.seqNum !== 2 ||
    _subLevels[_idx].questionComplexity[0]?.answer !== '1'
  ) {
    return _subLevels && _subLevels[_idx]?.level;
  }
  return _subLevels[0].level || 'low';
};

function SectionContent(props) {
  const {
    data,
    form,
    isEditing,
    history,
    selectMode,
    modelsData,
    handleGaugeValueChange,
    currentMode,
    ...rest
  } = props;
  const {
    level,
    levelPercent,
    subSectionComplexity,
    sectionNum,
    complexityText,
  } = data;
  // const [collapseData, setCollapseData] = useState([]);
  const [sectionLevel, setSectionLevel] = useState(level);
  const [sectionLevelPercent, setSectionLevelPercent] = useState(levelPercent);
  const [subLevels, setSubLevels] = useState([]);
  useEffect(() => {
    setSectionLevel(level);
  }, [level]);
  useEffect(() => {
    setSectionLevelPercent(levelPercent);
  }, [levelPercent]);
  useEffect(() => {
    const subs = deepCopy(subSectionComplexity);
    setSubLevels(subs);
  }, [subSectionComplexity]);
  useEffect(() => {
    if (isEditing || props.isRiskEditng) {
      window.localStorage.setItem('prompt', true);
      const res = form.getFieldsValue(true);
      const subSectionLevels = subSectionComplexity?.map((itm) => ({
        level: itm.level,
      }));
      form.setFieldsValue({
        ...res,
        sectionLevel: level,
        sectionLevelPercent: levelPercent,
        subSectionLevels,
      });
      window.localStorage.setItem('prompt', true);
    } else {
      window.localStorage.removeItem('prompt');
    }

    if (Array.isArray(subSectionComplexity?.[1]?.fullRiskMitigation)) {
      // for BPSI-risk-mitigation
      subSectionComplexity[1].fullRiskMitigation.forEach((item) => {
        item.forEach((subItem) => {
          form.setFieldsValue({
            risk: { [`${subItem.seqNum}--${subItem.level}`]: subItem.text },
          });
        });
      });
    }
  }, [isEditing, props.isRiskEditng]);

  // useEffect(() => {
  //   if (
  //     subSectionComplexity &&
  //     subSectionComplexity.length > 1 &&
  //     subSectionComplexity[1]?.subSectionName === 'BPSI'
  //   ) {
  //     setCollapseData(subSectionComplexity[1].questionComplexity);
  //   }
  // }, [subSectionComplexity?.[1]?.subSectionName === 'BPSI']);

  const handleLevelSelectChange = ({
    levelInfo,
    formName,
    index,
    subSectionName,
  }) => {
    let level = levelInfo.key.toLowerCase();
    level = level === 'med' ? 'medium' : level;
    const res = form.getFieldsValue(true);
    if (formName === 'sectionLevel') {
      form.setFieldsValue({
        ...res,
        sectionLevel: level,
        sectionLevelPercent: getPercentByLevelString(level),
      });
    }
    if (formName === 'subSectionLevels') {
      const subSectionLevels = res.subSectionLevels || [];
      subSectionLevels[index] = { level };
      form.setFieldsValue({ ...res, subSectionLevels });
    }
  };

  const handleGaugeChange = (gaugeValue) => {
    const res = form.getFieldsValue(true);
    form.setFieldsValue({
      ...res,
      sectionLevel: getLevelStringByPercent(gaugeValue),
      sectionLevelPercent: clipFloat(gaugeValue),
    });
    handleGaugeValueChange && handleGaugeValueChange(gaugeValue);
  };

  const showModalSave = (location) => {
    alert.confirmWithSave({
      onOk() {
        if (isEditing) {
          props.handleSubmit();
        }
      },
      onCancel(close) {
        if (isEditing) {
          props.handleCancel();
        }
        close();
        window.localStorage.removeItem('prompt');
        history.push({
          pathname: `${location.pathname}`,
        });
      },
    });
  };

  useEffect(
    () => () => {
      window.localStorage.removeItem('prompt');
    },
    [],
  );

  const handlePrompt = (location, text) => {
    const e = window.localStorage.getItem('prompt');
    if (e) {
      showModalSave(location);
      return false;
    }
    return true;
  };

  const changeQuesLevel = (model, { answer, level }, subIndex, quesIndx) => {
    const newModel = deepCopy(model);
    newModel.answer = answer;
    newModel.score = calculateScore(newModel);
    newModel.level = level;
    newModel.optionLevel = level;
    const subSection = deepCopy(subLevels);
    subSection[subIndex].questionComplexity[quesIndx] = newModel;

    const questionComplexitys = subSection
      ?.map((item) => item.questionComplexity)
      .flat();

    const subL = subSection[subIndex].questionComplexity.reduce(
      (num1, num2) =>
        levelScore[num1.level] > levelScore[num2.level] ? num1 : num2,
      { level: 'low' },
    );
    subSection[subIndex].level = subL.level;
    const res = calculateSectionScore(questionComplexitys);
    setSectionLevel(res);
    if (currentMode === 'auto') {
      setSectionLevelPercent({ low: 0, medium: 0.5, high: 1 }[res]);
    }
    setSubLevels(subSection);
  };

  return (
    <>
      <Prompt
        // when={shouldBlockNavigation}
        message={handlePrompt}
      />
      <div className="complexity-strategy-wrapper">
        {sectionLevel ? (
          <div>
            <Card
              isEditing={props.isEditing}
              selectMode={selectMode}
              className="top-card overall-top-card"
              value={{ level: sectionLevel, levelPercent: sectionLevelPercent }}
              content={
                <StrategyEditableContent
                  content={complexityText}
                  level={level}
                />
              }
              size="large"
              hasEditButton={true}
              onLevelSelectChange={(levelNum, levelInfo) => {
                handleLevelSelectChange({
                  levelInfo,
                  formName: 'sectionLevel',
                });
              }}
              handleGaugeChange={handleGaugeChange}
              useGauge
              {...rest}
            />
            {subSectionComplexity?.map((item, idx) => (
              <>
                <SubSectionContainer
                  selectMode={selectMode}
                  key={idx}
                  title={item.subSectionName}
                  level={getLevelShouldShow(subLevels, sectionNum, idx)}
                  onLevelSelectChange={(levelNum, levelInfo) => {
                    handleLevelSelectChange({
                      levelInfo,
                      formName: 'subSectionLevels',
                      index: idx,
                      subSectionName: item.subSectionName,
                    });
                  }}
                  currentMode={currentMode}
                >
                  {item.questionComplexity.map((itm, i) => {
                    const model = modelsData.find(
                      (m) => m.seqNum === itm.seqNum,
                    );
                    return (
                      <SectionContainer
                        subIndex={idx}
                        {...itm}
                        key={i}
                        {...props}
                        changeQuesLevel={(answer) => {
                          changeQuesLevel(model, answer, idx, i);
                        }}
                        // model={modelsData.find((m) => m.seqNum === itm.seqNum)}
                      />
                    );
                  })}
                </SubSectionContainer>
              </>
            ))}
          </div>
        ) : (
          <Skeleton active loadingparagraph={{ rows: 10 }} />
        )}
      </div>
    </>
  );
}

export default memo(withRouter(SectionContent));
